import React, { PureComponent } from 'react';

import { Card, Deck } from '@/shared/typings';
import CardTable, { HouseCards } from './CardTable';
import { groupBy } from 'ramda';

interface Props {
    cards: Card[];
    legacyCardsIds: Deck['setEraCards']['Legacy'];
    anomalyCardsIds: Deck['setEraCards']['Anomaly'];
    noHeader?: boolean;
}

export class NonDeckCardTable extends PureComponent<Props> {
    public render() {
        const { cards, legacyCardsIds, anomalyCardsIds, noHeader } = this.props;

        // Sort cards by sortOverride if available, otherwise maintain original order
        const sortedCards = [...cards].sort((a, b) => {
            // If both cards have sortOverride, sort by it
            if (a.sortOverride != null && b.sortOverride != null) {
                return a.sortOverride - b.sortOverride;
            }
            // If only one has sortOverride, prioritize it
            if (a.sortOverride != null) return -1;
            if (b.sortOverride != null) return 1;
            // Otherwise, sort by indexInExpansion (card number)
            return a.indexInExpansion.localeCompare(b.indexInExpansion);
        });

        const cardsByHouses = groupBy((card) => card.house, sortedCards);
        const houseCards: HouseCards[] = Object.keys(cardsByHouses).map(
            (houseId) => ({
                houseId,
                house: {
                    id: houseId,
                    name: houseId,
                    image: null,
                    inFilters: false,
                },
                cards: sortedCards,
            })
        );

        return (
            <CardTable
                houseCards={houseCards}
                legacyCardsIds={legacyCardsIds}
                anomalyCardsIds={anomalyCardsIds}
                showHouseIcon={false}
                otherCards={true}
                noHeader={noHeader}
            />
        );
    }
}
